import React from "react";
import TitanTroubleShooter from "./page/TitanTroubleShooter";

const App = () => {
  return (
    <div>
      <TitanTroubleShooter />
    </div>
  );
};

export default App;
